import React from 'react';
import TextField from '../../inputs/text-field/TextField';
import DropDown from '../../inputs/dropdown/Dropdown';
import styles from './PersonalCalculator.module.scss';
import { useTranslation } from 'react-i18next';

const PersonalCalculatorForm = () => {
  const countries = [
    { value: 'USA', label: 'USA' },
    { value: 'Pakistan', label: 'Pakistan' },
  ];

  const fuelTypes = [
    { value: 'petrol', label: 'Petrol' },
    { value: 'diesel', label: 'Diesel' },
    { value: 'electric', label: 'Electric' },
  ];

  const transportTypes = [
    { value: 'bus', label: 'Bus' },
    { value: 'train', label: 'Train' },
    { value: 'subway', label: 'Subway' },
  ];

  const { t } = useTranslation();

  return (
    <form className={styles.personalCalculatorForm}>
      {/* 1. Devices */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.personalCalculatorForm.deviceHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.personalCalculatorForm.deviceParagraph')}</p>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.computersLabel')}
            name='computers'
            type='number'
            placeholder='Enter number'
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.laptopsLabel')}
            name='laptops'
            type='number'
            placeholder='Enter number'
          />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.tabletsLabel')}
            name='tablets'
            type='number'
            placeholder='Enter number'
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.routersLabel')}
            name='routers'
            type='number'
            placeholder='Enter number'
          />
        </div>
      </div>

      {/* 2. Home */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.personalCalculatorForm.homeHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.personalCalculatorForm.homeParagraph')}</p>
        <div className={styles.inputGroup}>
          <DropDown
            label={t('calculatorView.personalCalculatorForm.homeCountryLabel')}
            name='country'
            option={countries}
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.membersLabel')}
            name='members'
            type='number'
            placeholder='Enter number'
          />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.DogsLabel')}
            name='dogs'
            type='number'
            placeholder='Enter number'
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.catsLabel')}
            name='cats'
            type='number'
            placeholder='Enter number'
          />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.RenewableEnergyLabel')}
            name='renewableEnergy'
            type='number'
            placeholder='Enter percentage'
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.livingAreaLabel')}
            name='livingArea'
            type='number'
            placeholder='Enter size'
          />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.monthsLabel')}
            name='heatingMonths'
            type='number'
            placeholder='Enter months'
          />
        </div>
      </div>

      {/* 3. Internet */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.personalCalculatorForm.internetHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.personalCalculatorForm.internetParagraph')}</p>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.dailyHoursliesure')}
            name='leisureHours'
            type='number'
            placeholder='Enter hours'
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.dailyHoursForWork')}
            name='workHours'
            type='number'
            placeholder='Enter hours'
          />
        </div>
      </div>

      {/* 4. Leisure */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.personalCalculatorForm.liesureHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.personalCalculatorForm.liesureParagraph')}</p>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.shoesLabel')}
            name='shoes'
            type='number'
            placeholder='Enter number'
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.plantsLabel')}
            name='pants'
            type='number'
            placeholder='Enter number'
          />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.tShirtsLabel')}
            name='tshirts'
            type='number'
            placeholder='Enter number'
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.shirtsLabel')}
            name='shirts'
            type='number'
            placeholder='Enter number'
          />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.percentageofSecondHandPurchases')}
            name='secondHand'
            type='number'
            placeholder='Enter percentage'
          />
        </div>
      </div>

      {/* 5. Nutrition */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.personalCalculatorForm.nutritionHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.personalCalculatorForm.nutritionParagraph')}</p>
        <div className={styles.inputGroup}>
          <DropDown
            label={t('calculatorView.personalCalculatorForm.nutritionCountryLabel')}
            name='country'
            option={countries}
          />
        </div>
      </div>

      {/* 6. Trip */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.personalCalculatorForm.tripHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.personalCalculatorForm.tripParagraph')}</p>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.yearlyShortHaulFlightsLabel')}
            name='shortFlights'
            type='number'
            placeholder='Enter number'
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.yearlyLongHaulFlightslabel')}
            name='longFlights'
            type='number'
            placeholder='Enter number'
          />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.personalCalculatorForm.yearlyHotelStaysLabel')}
            name='hotelStays'
            type='number'
            placeholder='Enter number'
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.averageHotelStarRating')}
            name='hotelRating'
            type='number'
            placeholder='Enter rating'
          />
        </div>
      </div>

      {/* 7. Transport */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.personalCalculatorForm.transportHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.personalCalculatorForm.transportParagrraph')}</p>
        <div className={styles.inputGroup}>
          <DropDown
            label={t('calculatorView.personalCalculatorForm.fuelTypeLabel')}
            name='fuelType'
            option={fuelTypes}
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.yearlyDistanceDriven')}
            name='distanceDriven'
            type='number'
            placeholder='Enter distance'
          />
        </div>
        <div className={styles.inputGroup}>
          <DropDown
            label={t('calculatorView.personalCalculatorForm.transportTypeLabel')}
            name='transportType'
            option={transportTypes}
          />
          <TextField
            label={t('calculatorView.personalCalculatorForm.annualDistanceTraveledLabel')}
            name='distanceTraveled'
            type='number'
            placeholder='Enter distance'
          />
        </div>
      </div>
    </form>
  );
};

export default PersonalCalculatorForm;
